// GPS del navegador/celular: se usa para marcar la ubicación de un
// dispositivo "estando al lado del equipo" al instalarlo en el campo.
export function detectBrowserLocation(): Promise<{ lat: number; lon: number }> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Tu navegador no soporta geolocalización.'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      (err) => reject(new Error(err.message || 'No pudimos obtener tu ubicación.')),
      { timeout: 10000, enableHighAccuracy: true }
    );
  });
}
